import featuredOffersLogo from './featuredOffersLogo';

export default featuredOffersLogo;
